import { Sizes } from "./interfaces"

export const SIZES: Record<Sizes, { width: string; minWidth: string; height: string }> = {
    XS: {
        width: "24px",
        minWidth: "24px",
        height: "24px",
    },
    XL: {
        width: "40",
        minWidth: "40",
        height: "40",
    },
    S: {
        width: "48px",
        minWidth: "48px",
        height: "48px",
    },
    W80: {
        width: "80px",
        minWidth: "80px",
        height: "80px",
    },
    SL: {
        width: "88px",
        minWidth: "88px",
        height: "88px",
    },
    M: {
        width: "135px",
        minWidth: "135px",
        height: "135px",
    },
    L: {
        width: "160px",
        minWidth: "160px",
        height: "160px",
    },
    XXL: {
        width: "184px",
        minWidth: "184px",
        height: "184px",
    },
}

export const STYLES: Partial<Record<Sizes, { lineHeight: string; fontSize: string }>> = {
    XS: {
        fontSize: "14px",
        lineHeight: "24px",
    },
    SL: {
        lineHeight: "88px",
        fontSize: "48px",
    },
}
